// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"56":"2fe76e58","453":"6990b4c2"}[chunkId] + ".chunk.js");